import { TRANSLATION_ID, AFTERSALES_RULES, AFTERSALES_CHECKS, CANCEL_AFTERSALES } from 'constants/fareConditions';
import serviceTypeCodes from 'constants/serviceTypeCodes';

export const buildFareConditionItems = ({ bookingItems = [] }) =>
  bookingItems.reduce(
    (
      acc,
      { passenger, afterSalesRules, canBeRebooked, canBeCancelled, canBeUpgrade, canChangeSeat, canChangeName, canBeRefunded, cancelled }
    ) => {
      if (passenger && passenger.type && !acc.types.has(passenger.type) && !cancelled) {
        return {
          types: acc.types.add(passenger.type),
          details: [
            ...acc.details,
            {
              afterSalesRules,
              canBeRebooked,
              canBeCancelled,
              canBeRefunded,
              canBeUpgrade,
              canChangeSeat,
              canChangeName,
              passenger,
              type: passenger.type
            }
          ]
        };
      }

      return acc;
    },
    { types: new Set(), details: [] }
  );

export const areAllAfterSalesChecksFalseForGivenRule = ({ details, type, afterSalesKey }) =>
  details.some(({ passenger, ...rest }) =>
    Array.isArray(AFTERSALES_CHECKS[afterSalesKey])
      ? passenger?.type === type && AFTERSALES_CHECKS[afterSalesKey].every((check) => rest[check] !== true)
      : passenger?.type === type && rest[AFTERSALES_CHECKS[afterSalesKey]] !== true
  );

export const shouldDisplayNotPossibleFareConditionsMessage = ({ aftersalesConditionsToDisplay, afterSalesKey }) =>
  aftersalesConditionsToDisplay.some(
    ({ allAfterSalesChecksFalseForGivenRule, canBeRefunded }) =>
      allAfterSalesChecksFalseForGivenRule ||
      (afterSalesKey === CANCEL_AFTERSALES && !allAfterSalesChecksFalseForGivenRule && !canBeRefunded)
  );

export const displayAfterSalesNotPossibleMessage = ({ afterSalesKey, cannotBeCancelledAndRefunded, intl }) => {
  if (afterSalesKey === CANCEL_AFTERSALES && cannotBeCancelledAndRefunded) {
    return intl.formatMessage({
      id: `afterSalesRule.cancel.notCancellable`
    });
  }

  return intl.formatMessage({
    id: `${TRANSLATION_ID}.${AFTERSALES_RULES[afterSalesKey]}NoPossible`
  });
};

export const enableFaresConditionsSNSummated = ({ journey = {} }) =>
  journey.serviceType?.code !== serviceTypeCodes.SNCF || (journey.serviceType?.code === serviceTypeCodes.SNCF && journey.isSummatedFare);
export const showModalFareConditions = ({ journey = {} }) =>
  journey.cancelled !== true && journey.serviceType?.code !== serviceTypeCodes.THALYS && enableFaresConditionsSNSummated({ journey });
